import type { KYCQuestionDefinition } from '@anchorage/graphql/generated';
import type { CustomLinkProps } from '@anchorage/utils';
import { parseSanitize } from '@anchorage/utils';
import { FormInput, reactHookForm } from '@latitude/form';
import type { ComponentType } from 'react';

type Props = {
  question: KYCQuestionDefinition;
  isDisabled?: boolean;
  trackFn?: (questionId: string) => void;
  CustomLink?: ComponentType<CustomLinkProps>;
};

function TextFieldComponent({
  question,
  isDisabled = false,
  trackFn = () => {},
  CustomLink,
}: Props) {
  const { control } = reactHookForm.useFormContext();

  return (
    <FormInput
      // The footer is sanitized HTML and may contain bullet lists.
      wrapperClassname="[&_ul_li]:ml-spacing-sys-spacing-16 [&_ul_li]:list-disc"
      message={parseSanitize(question?.footer, CustomLink) || ''}
      control={control}
      name={`${question.id}.freeformText`}
      readOnly={isDisabled}
      rawProps={{ maxLength: 512, onChangeCapture: () => trackFn(question.id) }}
      inputSize="medium"
      onClear={() => trackFn?.(question.id)}
      data-testid={`input-${question.id}`}
    />
  );
}

export { TextFieldComponent };
